import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { PriceOfferListPathParameters } from 'api/actions/price-offer-list/price-offer-list-path-parameters';
import { PriceOfferListResponse } from 'api/actions/price-offer-list/price-offer-list-response';

type PriceOfferListQueryParameters = Record<string, any>;

/**
 * The path of the PriceOfferList action.
 */
export const priceOfferListActionPath = new SweetPath<keyof PriceOfferListPathParameters>('/api/price-offer/list', {
  path: '{param}',
});

/**
 * Creates a contextualized PriceOfferList actions.
 */
export default function createPriceOfferListAction(axios: AxiosInstance) {
  return function priceOfferListAction({
    headers = {},
    query = {},
  }: { headers?: AxiosRequestConfig<any>['headers']; query?: PriceOfferListQueryParameters } = {}) {
    const path = priceOfferListActionPath.original;

    return axios.request<PriceOfferListResponse, PriceOfferListResponse>({
      method: 'get',
      url: path,
      params: query,

      headers,
    });
  };
}
